import { CompletedExtractionType, ModeType } from '../../types';
import ExtractionsHistory from '../extractionHistory';
import PagesModeControls from '../pagesModeControls';
import { FullPageNavigation } from '../pageNavigation';
import './styles.css';

type ExtractionHeaderPropsType = {
    mode: ModeType;
    setMode: (mode: ModeType) => void;
    completedExtractions: CompletedExtractionType[];
    currentPage: number;
    handleNextPage: () => void;
    handlePrevPage: () => void;
    handleSetPage: (page: number) => void;
    numberOfPages: number;
};

const ExtractionHeader = ({
    completedExtractions,
    mode,
    setMode,
    currentPage,
    handleNextPage,
    handlePrevPage,
    handleSetPage,
    numberOfPages,
}: ExtractionHeaderPropsType) => {
    return (
        <header className="extraction-header">
            <PagesModeControls
                className="extraction-header__item extraction-header__item--start"
                mode={mode}
                setMode={setMode}
            />
            <FullPageNavigation
                className="extraction-header__item extraction-header__item--middle"
                currentPage={currentPage}
                handleNextPage={handleNextPage}
                handlePrevPage={handlePrevPage}
                handleSetPage={handleSetPage}
                numberOfPages={numberOfPages}
            />
            <ExtractionsHistory
                className="extraction-header__item extraction-header__item--end"
                completedExtractions={completedExtractions}
            />
        </header>
    );
};

export default ExtractionHeader;
